import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  useFetchAuthorisation,
  authorisationConverter,
  useFetchUserData,
} from "../../utils/AppFunctions";
import config from "../../app-config";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import { MdAdd, MdEdit } from "react-icons/md";
import DataTable from "../../components/ui/DataTable";
import { fetch_all_accounts } from "../../api/accountsAPI";
import { tidy_date } from "../../utils/helper";
import { fetch_all_claims } from "../../api/claimsAPI";
import Button from "../../components/ui/Button";

export default function ClaimsPage() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true)
  const [claimsData, setClaimsData] = useState([])

  const table_columns = [
    {
      header: "Description",
      accessor: "description",
    },
    {
      header: "Amount",
      accessor: "claim_value",
      modifier: (data, row) => row?.currency ? `${row.currency} ${data} (SGD ${data / row.exchange_rate})` : `SGD ${data}`
    },
    {
      header: "Account",
      accessor: "account_data.name",
      modifier: (data, row) => data
    },
    {
      header: "Status",
      accessor: "claim_status",
      modifier: (data) => {
        switch (data) {
          case "pending":
            return "Pending Approval"
          case "approved":
            return "Approved"
          case "rejected":
            return "Rejected"
          case "process_payment":
            return "Processing Payment"
          case "paid":
            return "Reimbursed"
          default:
            return data
        }
      }
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (value, row) => `${tidy_date(row.updatedAt)}`
    },
    {
      header: "Date Submitted",
      accessor: "createdAt",
      modifier: (data) => tidy_date(data)
    }
  ]

  useEffect(() => {
    fetchClaims()
  }, [])

  const fetchClaims = async () => {
    setLoading(true)
    const { data, error, message, status } = await fetch_all_claims()
    if (error) return console.log("Error fetching accounts:", message)
    setClaimsData(data.reverse())
    setLoading(false)
  }




  return (
    <AdminLayout navSelected={"Claims"}
      toolbar={
        <>
          <h1 className="text-2xl font-bold text-gray-900">
            Claims
          </h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/claims/details?claim_id=new")
            }}
          >
            <MdAdd size={16} />
            Submit Claims
          </button>
        </>
      }
    >
      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={claimsData}
            enableActions
            enablePagination
            accessorKey={'id'}
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/claims/details?claims_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}